import { render, staticRenderFns } from "./proViewFile.vue?vue&type=template&id=516c6072&scoped=true&"
import script from "./proViewFile.vue?vue&type=script&lang=js&"
export * from "./proViewFile.vue?vue&type=script&lang=js&"
import style0 from "./proViewFile.vue?vue&type=style&index=0&id=516c6072&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516c6072",
  null
  
)

export default component.exports